import React from 'react'
import { Link } from 'react-router-dom'

export default (props) => {
	const {
		title,
	} = props

	if (!title) {
		return null
	}

	const styles = {
		image: {
			backgroundImage: `url('${title.artworkUrls.poster}')`,
		}
	}

	return (
		<div className="billboard">
			<div className="billboard__image" style={styles.image} />
			<div className="billboard__gradient" />
			<div className="billboard__content">
				<div className="billboard__content-item">
					<div className="billboard__name">{title.name}</div>
					<div className="billboard__overview">
	          <div className="billboard__specs">
	            <span className="billboard__spec-item">{title.meta.year}</span>
	            <span className="billboard__spec-item">{`${title.meta.duration} mins`}</span>
	          </div>
          </div>
					<Link className="billboard__play-button" to="/watch/832493">Play</Link>
				</div>
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/mobile/components/billboard/index.js